import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { ProcessListService } from 'src/services/process-list.service';
import { CreateProcessListDialogComponent } from '../create-process-list-dialog/create-process-list-dialog.component';
import { ProcessListNameDialogComponent } from '../process-list-name-dialog/process-list-name-dialog.component';
import { ProcessListUserComponent } from '../process-list-user/process-list-user.component';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { CandidatesApprovalComponent } from '../candidates-approval/candidates-approval.component';
import { ProcessListUnarchiveDialogComponent } from '../process-list-unarchive-dialog/process-list-unarchive-dialog.component';
import { NotificationService } from 'src/services/notification.service';
import { ProcessListShareDialogComponent } from '../process-list-share-dialog/process-list-share-dialog.component';

@Component({
  selector: 'app-process-list',
  templateUrl: './process-list.component.html',
  styleUrls: ['./process-list.component.scss']
})
export class ProcessListComponent implements OnInit {

  processLists: Array<any> = [];
  submiting: boolean = false;
  isSmallScreen$: Observable<boolean>;
  processListIndex: number = -1;
  currentLead: any;
  vacanciesProcess: { [key: string]: number } = {};
  hiredProcess: { [key: string]: number } = {};
  verifyQTDProcess: { [key: string]: boolean } = {};
  totalCandidatesToApproval: number = 0;
  user: any;
  currentProcessListId: any;
  intervalId: any;

  public set ProcessIndex(index: number) {
    localStorage.setItem('processListIndex', index.toString());
  }

  public get ProcessIndex(): number {
    const index = localStorage.getItem('processListIndex');
    return index != null ? parseInt(index) : -1;
  }

  constructor(
    @Inject('API_ENDPOINT') private apiUrl: string,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar,
    private breakpoint: BreakpointObserver,
    private processList: ProcessListService,
    private router: Router,
    private notificationService: NotificationService,
  ) { }

  ngOnInit(): void {

    this.isSmallScreen$ = this.breakpoint
      .observe([Breakpoints.XSmall, Breakpoints.HandsetPortrait])
      .pipe(
        map(state => {
          return state.matches
        })
      )

    const subject = new Subject();
    subject.subscribe(
      (result: any) => {

        const { trigger, scope } = result;
        if (scope.indexOf('process_list') > -1)
          this.submiting = trigger === 'pre';

      }
    )
    this.http.setLoadingIndicator(subject)
    this.getProcessList();
  }

  public getTotalCandidatesToApproval(processListId) {
    this.http.get('process_list:total_lead', { processList: processListId, approvalStatus: true })
      .subscribe(
        (result: any) => this.totalCandidatesToApproval = (result.data.records as number),
        err => this.errorReport.showMessage(err)
      )
  }

  openCandidatesToApproval(processListId) {
    const options = {
      width: '800px',
      disableClose: true,
      data: {
        processListId
      }
    }
    this.dialog.open(CandidatesApprovalComponent, options)
      .afterClosed()
      .subscribe(() => {
        this.getTotalCandidatesToApproval(processListId);
        this.processList.loadCandidates(processListId);
        this.getProcessList();
      });
  }

  getProcessList() {

    const user = JSON.parse(localStorage.getItem('token'));
    this.currentLead = user.signature_status;
    this.http.get('process_list', { company: user.company_id, id: user.id })
      .subscribe(
        (result: any) => {
          this.processLists = result.data;
          this.initializeVerifyQTDProcess(this.processLists);
        },
        err => this.errorReport.showMessage(err)
      )

  }

  getProcessListStatus(processList) {

    if (processList.status === 'pending')
      return 'Pendente';

    if (processList.status === 'read')
      return 'Ativo';

    if (processList.status === 'new')
      return 'Novo (sem candidatos selecionados)';

    return 'Finalizado';

  }

  deleteProcessList(args, processList: any) {

    args.stopPropagation();

    if (!confirm(`Deseja realmente deletar o processo seletivo ${processList.name}`))
      return;

    this.http.delete('process_list', { id: processList.id })
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.snackbar.open('Processo seletivo deletado com sucesso!', 'OK', { duration: 3000 });
            this.getProcessList();
          }
        },
        err => this.errorReport.showMessage(err)
      )

  }

  ArchiveProcessList(args, processList: any) {

    args.stopPropagation();

    if (!confirm(`Deseja realmente arquivar o processo seletivo ${processList.name}`))
      return;

    this.http.save('process_list:archive', { id: processList.id })
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.snackbar.open('Processo seletivo arquivado com sucesso!', 'OK', { duration: 3000 });
            this.getProcessList();
          }
        },
        err => this.errorReport.showMessage(err)
      )

  }

  userProcessList(processList) {

    const options = {
      width: '800px',
      disableClose: true,
      data: {
        processList
      }
    };
    this.dialog.open(ProcessListUserComponent, options)
      .afterClosed()
      .subscribe(
        result => {
          this.getProcessList();
        }
      );

  }

  newProcessList() {

    const currentUser = JSON.parse(localStorage.getItem('token'));

    this.http.list('company', { id: currentUser.company_id })
      .subscribe(
        (result: any) => {
          const { data } = result;

          // if ((data.free_account == 1 || currentUser.signature_status != 'ACTIVE') && this.processLists.length > 0) {
          //   this.snackbar.open('Somente um processo seletivo pode ser criado com o plano grátuito ou até o pagamento ser aprovado', 'OK')
          // } else {

          if ((currentUser.signature_status == 'ACTIVE' || currentUser.signature_status == 'TRIAL') && currentUser.account_type !== 'candidate') {

            const options = {
              width: '1200px',
              disableClose: true
            };
            this.dialog.open(ProcessListNameDialogComponent, options)
              .afterClosed()
              .subscribe(
                result => {
                  this.getProcessList();
                }
              );

          } else {

            this.notificationService.showAccountActivationMessage();

          }

        }
      );

  }

  openProcessList(processList) {

    this.user = JSON.parse(localStorage.getItem('token'));

    if (
      this.user.signature_status !== 'ACTIVE' && this.user.signature_status !== 'TRIAL' && this.user.account_type !== 'candidate'
    ) {

      this.notificationService.showAccountActivationMessage();

    } else {

      // if (processList.status === 'new') {
      //   this.processList.clear();
      //   this.router.navigate(['/', 'recruiter', 'report'], { queryParams: { id: processList.id } });
      // } else {

      if (
        this.user.signature_status !== 'ACTIVE' && this.user.signature_status !== 'TRIAL' && this.user.account_type !== 'candidate'
      ) {

        this.notificationService.showAccountActivationMessage();

      } else {

        // if (processList.status === 'new') {
        //   this.processList.clear();
        //   this.router.navigate(['/', 'recruiter', 'report'], { queryParams: { id: processList.id } });
        // } else {

        const options = {
          width: '800px',
          disableClose: true,
          data: {
            processList
          }
        };
        this.dialog.open(CreateProcessListDialogComponent, options)
          .afterClosed()
          .subscribe(
            result => {
              if (result)
                this.getProcessList()
            }
          );

        // }

      }

    }

  }

  editeProcessList(processList) {

    const options = {
      width: '1200px',
      disableClose: true,
      data: {
        processList
      }
    };
    this.dialog.open(ProcessListNameDialogComponent, options)
      .afterClosed()
      .subscribe(
        result => {
          if (result)
            this.getProcessList()
        }
      );

  }

  activeProcessList(processList) {

    const Processid = processList.id

    this.http.save('process_list:finish', { id: Processid })
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.getProcessList();
            this.snackbar.open('Processo Reativado com sucesso!', 'OK', { duration: 3000 });
          }
        },
        err => this.errorReport.showMessage(err)
      )

  }

  VerifyQtdinProcess(processList) {

    const Processid = processList.id
    const StatusProcess = processList.status;

    if (StatusProcess != 'finished') {

      this.http.list('process_list:verify_vacancy', { id: Processid })
        .subscribe(
          (result: any) => {
            if (result.type === 'OK') {
              const data = result.data[0];
              const qtdVagas = data.qtdVagas;
              const qtdContratados = data.qtdContratados;

              if (qtdVagas == qtdContratados) {
                const icon = 'warning';
                const icon_class = 'font-icon';
                const message = `Não há mais vagas disponíveis neste processo seletivo.`;
                const message2 = `Obs: Todas as vagas disponíveis foram preenchidas.`;
                const buttons = [
                  { name: 'Encerrar Processo', value: 1, class: 'primary' },
                  { name: 'Aumentar Número de Vagas', value: 2, class: 'success' },
                  { name: 'Cancelar', value: false, class: 'danger' }
                ];

                const options = {
                  disableClose: true,
                  data: {
                    icon,
                    icon_class,
                    message,
                    message2,
                    buttons
                  }
                };

                this.dialog.open(GenericDialogComponent, options)
                  .afterClosed()
                  .subscribe(
                    result => {

                      if (result == 1) {

                        const data = {
                          id: Processid
                        }

                        this.http.save('process_list:conclude', data)
                          .subscribe(
                            (result: any) => {

                              if (result.type === 'OK') {
                                this.getProcessList();
                                this.snackbar.open('Processo Encerrado com sucesso!', 'OK', { duration: 3000 });
                              }
                            },
                            err => this.errorReport.showMessage(err)
                          )

                      } else if (result == 2) {
                        this.editeProcessList(processList);
                      } else {
                        return;
                      }

                    }
                  );

              }

            }
          }
        );
    }

  }

  async initializeVerifyQTDProcess(processLists: any[]): Promise<void> {
    this.verifyQTDProcess = {};

    for (const processList of processLists) {
      this.verifyQTDProcess[processList.id] = false;
      await this.QtdVacancyinProcess(processList.id);
    };

  }

  QtdVacancyinProcess(processList: any): void {
    const Processid = processList;
    if (this.verifyQTDProcess[Processid] === false) {
      this.http.list('process_list:verify_vacancy', { id: Processid })
        .subscribe(
          (result: any) => {
            if (result.type === 'OK') {
              const data = result.data[0];
              const qtdVagasProcesso = data.qtdVagas;
              const qtdContratadosProcesso = data.qtdContratados;
              this.verifyQTDProcess[Processid] = true;

              this.vacanciesProcess[Processid] = qtdVagasProcesso - qtdContratadosProcesso;
              this.hiredProcess[Processid] = qtdContratadosProcesso;
            }
          },
          err => this.errorReport.showMessage(err)
        );
    }
  }

  onHireCandidates() {
    this.getProcessList(); // Chama o método getProcessList após contratar candidatos
  }

  unarchiveProcessList() {

    const currentUser = JSON.parse(localStorage.getItem('token'));

    const options = {
      width: '800px',
      disableClose: true,
      data: {
        id: currentUser.company_id
      }
    };
    this.dialog.open(ProcessListUnarchiveDialogComponent, options)
      .afterClosed()
      .subscribe(
        result => {
          this.getProcessList();
        }
      );

  }

  public onPanelOpened(processList) {
    this.currentProcessListId = processList.id;
    // Inicia o loop a cada 1 minuto
    this.intervalId = setInterval(() => {
      this.getTotalCandidatesToApproval(this.currentProcessListId);
    }, 15000); // 60000 ms = 1 minuto
  }

  public onPanelClosed() {
    // Limpa o intervalo ao fechar o painel
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  ngOnDestroy() {
    // Garante que o intervalo seja limpo ao destruir o componente
    this.onPanelClosed();
  }

  OpenProcessListShare(processList: any) {

    const options = {
      width: '800px',
      disableClose: true,
      data: {
        processList: processList,
        apiUrl: this.apiUrl,
        currentProcessListId: this.currentProcessListId
      }
    };
    this.dialog.open(ProcessListShareDialogComponent, options)
      .afterClosed()
      .subscribe(
        result => {
          // aqui pode definir alguma função se necessario
        }
      );

  }

}
